import { render, staticRenderFns } from "./MedicineEdit.vue?vue&type=template&id=25242bd2&scoped=true&"
import script from "./MedicineEdit.vue?vue&type=script&lang=js&"
export * from "./MedicineEdit.vue?vue&type=script&lang=js&"
import style0 from "./MedicineEdit.vue?vue&type=style&index=0&id=25242bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25242bd2",
  null
  
)

export default component.exports